import { gql } from '@apollo/client';

export const ACTIVE_ANNOUNCEMENT_QUERY = gql`
  query GetActiveAnnouncement(
    $brandId: ID
    $locale: String
    $isProvider: Boolean!
    $isPatient: Boolean!
  ) {
    activeAnnouncement(brandId: $brandId, locale: $locale) {
      id
      title @include(if: $isPatient)
      description @include(if: $isPatient)
      callToAction @include(if: $isPatient)
      supportLinkType @include(if: $isPatient)
      supportTeamText @include(if: $isPatient)
      providerInfo @include(if: $isProvider)
    }
  }
`;
